import { IMAGES } from "../../constants/contact";

export function Fedelta() {
  return (
    <section id="fedelta" data-testid="fedelta-section" className="py-24 px-6 max-w-6xl mx-auto">
      <div className="border border-[#1B4D3E] p-8 md:p-14 bg-white grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
        <div className="lg:col-span-7">
          <span className="font-sans text-xs uppercase tracking-widest text-[#1B4D3E] font-bold">SumUp Local</span>
          <h2 className="text-3xl md:text-4xl font-normal text-[#1B4D3E] mt-2 mb-4">
            Fidelizzazione integrata al POS.
          </h2>
          <p className="font-sans text-sm md:text-base text-[#5A564F] leading-relaxed mb-6">
            I clienti accumulano punti automaticamente quando pagano con carta. Nessuna applicazione da scaricare né
            tessere cartacee da stampare.
          </p>
          <p className="font-sans text-xs text-[#736F67] italic">Configurazione inclusa nella consulenza iniziale.</p>
        </div>
        <div className="lg:col-span-5">
          <div className="aspect-square relative overflow-hidden frame-drift border border-[#E3DFD7]">
            <img
              src={IMAGES.loyalty}
              alt="Cliente che paga con lo smartphone accumulando punti fedeltà"
              className="absolute inset-0 w-full h-full object-cover"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
